import About from './About';
import Story from './OurStory';
import People from './People';

export default About;
export const OurStory = Story;
export const KeyPeople = People;
